// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Navbar from "./Components/Navbar";
import About from "./About";
import Rules from "./Rules";
import NewMemberForm from "./NewMemberForm";
import ApplicationHomepage from "./ApplicationHomepage";
import FormerMemberForm from "./FormerMemberApplication";
import Footer from "./Footer";
import Season4Launch from "./News/Season4Launch";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/application" element={<ApplicationHomepage />} />
            <Route path="/new-member-application" element={<NewMemberForm />} />
            <Route
              path="/former-member-application"
              element={<FormerMemberForm />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/news/season4launch" element={<Season4Launch />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
